<template>
  <div :class="`vue-alert ${type}`">
    <div v-if="message" v-html="message"></div>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  name: "Alert",
  props: {
    messages: {
      type: Array,
      default: [],
    },
    type: {
      type: String,
      default: 'success',
    },
  },
  computed: {
    message() {
      return this.messages.join('<br>');
    },
  },
}
</script>